import { createFileRoute } from "@tanstack/react-router";
import { routeOptions } from "@/pages/checkout";
import { withAlternates } from "@/lib/route-i18n";

export const Route = createFileRoute("/checkout")(withAlternates(routeOptions, "/checkout"));
